import React from 'react';
import {withTranslation} from "react-i18next";

let noRewardsFoundComponent = ({t}) => {
	return <div className="reward-card col-sm-12 col-md-6">
		<div  className="reward-card-content no-rewards-available">
			<div className="reward-title">{t('rewards.noneAvailable')}</div>
		</div>
	</div>
};

export default withTranslation() (noRewardsFoundComponent)